<template>
  <div class="treemap-container">
    <apexchart
      type="treemap"
      :height="chartHeight"
      :options="chartOptions"
      :series="series"
    />
  </div>
</template>

<script>
export default {
  name: "TreeMap",
  props: {
    data: { type: Object, required: true },
    height: { type: [Number, String], default: 360 },
  },
  data() {
    return {
      series: [{ data: [] }],
      chartOptions: {
        chart: {
          type: "treemap",
          toolbar: { show: false },
          animations: { enabled: false },
        },
        legend: { show: false },
        plotOptions: {
          treemap: {
            distributed: true,
            enableShades: false,
          },
        },
        dataLabels: {
          enabled: true,
          // NOTA: para multi-línea en ApexCharts, devolvemos un ARRAY
          formatter: (text, opts) => {
            try {
              const sIdx = opts.seriesIndex;
              const dIdx = opts.dataPointIndex;
              const data = opts.w.config.series[sIdx].data;
              if (!data || !data.length) return text;

              const val = data[dIdx]?.y ?? 0;
              const total = data.reduce((a, b) => a + (b?.y ?? 0), 0) || 1;
              const pct = ((val / total) * 100).toFixed(1) + "%";

              // Línea 1: nombre (text) — Línea 2: porcentaje
              return [text, pct];
            } catch (e) {
              return text;
            }
          },
          offsetY: 0,
          style: {
            fontSize: "16px",
            fontWeight: 700,
            colors: ["#ffffff"], // color base; luego lo ajustamos por bloque en 'rendered'
          },
          // Muy importante para que Centre bien el multi-line
          textAnchor: "middle",
        },
        tooltip: {
          theme: "light",
          custom: ({ seriesIndex, dataPointIndex, w }) => {
            const d = w.config.series[seriesIndex].data[dataPointIndex];
            if (!d) return "";
            return `
              <div style="padding:8px; font-size:13px; color:#333; line-height:1.4;">
                <b>Producto:</b> ${d.producto || d.x}<br/>
                <b>Pertinencia:</b> ${d.pertinencia || "No definida"}<br/>
                <b>Práctica:</b> ${d.practica || "No definida"}<br/>
                <b>Sellos:</b> ${d.sellos || "No tiene"}<br/>
                <b>Producción anual:</b> ${d.produccion || "No definida"}
              </div>`;
          },
        },
      },
    };
  },
  computed: {
    chartHeight() {
      return typeof this.height === "number" ? this.height : 360;
    },
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.updateSeries(newVal);
      },
    },
  },
  methods: {
    updateSeries(input) {
      if (!input || !Array.isArray(input.serie)) {
        console.warn("⚠️ TreeMap sin datos válidos:", input);
        return;
      }
      // 🎨 Mapa de colores fijo por producto
      const colorMap = {
        "Pimiento": "#62B238",
        "Ají": "#F4731B",
        "Dátil": "#C35B1B",
        "Tomate": "#DC1933",
        "Aceituna": "#488A29",
        "Tomate Cherry": "#F31C17",
        "Maíz": "#FAD829",
        "Albahaca": "#3ABB5C",
        "Maracuyá": "#E1BF26",
        "Guayaba": "#EB8180",
        "Limón": "#E6ED6F",
        "Ajo": "#E7A6E1",
        "Berenjena": "#2A7629",
        "Orégano": "#44B443",
        "Pepino": "#9DE080",
      };

      const serie = this.data.serie.map(item => ({
        ...item,
        color: colorMap[item.producto] || "#2F48A3", // fallback si no está en el mapa
      }));

      this.series = [{ data: serie }];
      this.chartOptions.colors = serie.map(i => i.color);
    },

  },
};
</script>

<style scoped>
.treemap-container {
  width: 100%;
  min-height: 320px;
}
</style>
